import { render, staticRenderFns } from "./ReleaseNotes.vue?vue&type=template&id=bab5e264"
import script from "./ReleaseNotes.vue?vue&type=script&lang=js"
export * from "./ReleaseNotes.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNotes.vue?vue&type=style&index=0&id=bab5e264&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports